<template>
  <div class="logistics-fleet-list" style="overflow:auto">
    <!-- if sorting by category -->
    <div v-if="sortBy === 'category'" style="width:100%">
      <span class="buttons is-centered single-line" style="width:100vw; padding-bottom:12px">
        <span
          v-show="category"
          class="button is-info is-small is-rounded"
          :class="{'is-outlined': category}"
          @click="category = null"
        >
          <span class="icon">
            <i class="fa fa-times-circle" />
          </span>
        </span>
        <span
          v-for="c in categories"
          v-show="c"
          :key="c"
          class="button is-info is-small has-text-weight-medium"
          :class="{'is-outlined': category !== c}"
          @click="category = c"
        >
          <!-- {{ translateCategory(c) }} -->
          {{c}}
        </span>
      </span>
    </div>

    <!-- if sorting by filter -->
    <!-- <div v-if="sortBy === 'filter'" style="width:100%">
      <span class="buttons is-centered single-line" style="width:100vw; padding-bottom:12px">
        <span
          v-show="filter"
          class="button is-primary is-small is-rounded"
          :class="{'is-outlined': filter}"
          @click="filter = null"
        >
          <span class="icon">
            <i class="fa fa-times-circle" />
          </span>
        </span>
        <span
          v-for="f in filters"
          v-show="f"
          :key="f"
          class="button is-primary is-small has-text-weight-medium"
          :class="{'is-outlined': filter !== f}"
          @click="filter = f"
        >{{ translateFilter(f) }}</span>
      </span>
    </div>-->

    <div class="card" v-if="noVehicles">
      <div class="card-content" style="padding:12px" @click="refreshPage">
        <span class="button is-white has-text-primary">No Vehicles Fit Your Search</span>
        <a class="button is-rounded is-primary is-outlined">{{ $t("try-again") }}</a>
        <!-- should clear the search terms and categories etc, not reload page... -->
      </div>
    </div>

    <div class="fleet-list no-scrollbar">
      <div
        class="card shop-card"
        v-for="v in filteredVehicles"
        :key="v.id"
        @click="openDriverModal(v)"
      >
        <div class="card-content" style="padding:6px;">
          <div class="media" style="margin-bottom:0;">
            <div class="media-left" style="margin-right:8px">
              <figure class="image">
                <img :src="userProfilePic(v)" />
              </figure>
            </div>
            <div class="media-content" style="margin-top:6px; overflow:hidden">
              <span class="has-text-weight-medium has-text-link shop-name">{{ shortName(v) }}</span>
              <span class="is-pulled-right" style="height:0">
                <span v-if="isWorking(v)" class="has-text-success">
                  <span class="icon">
                    <i class="fa fa-spinner fa-spin" />
                  </span>
                  &nbsp;{{ $t("logistics.working") }}
                </span>
                <span v-else class="has-text-danger">{{ $t("logistics.not-working") }}</span>
              </span>
              <br />
              <!-- <span class="tag is-info">{{ b.business_type }}</span> -->
              <span class="tag is-info">{{ businessType(v) }}</span>
              <!-- <span
                class="tag is-light has-text-weight-semibold distance"
                :class="distanceColor(500)"
                style="margin-left:-3px; border-radius:0; border-top-right-radius:5px; border-bottom-right-radius:5px"
              >
                <span v-if="b.distance">{{ b.prettyDistance }}</span>
                <span v-else>
                  <i class="fa fa-spinner fa-spin has-text-info" />
                </span>
              </span>-->
              <span class="tags has-addons is-pulled-right">
                <!-- <span v-if="isWorking(v)" class="tag is-grey">{{minutesAgo(v.updated_at)}}</span> -->
                <span class="tag is-grey">{{ timeAgo(v.updated_at) }}</span>
                <span v-if="hasActiveJob(v)" class="tag is-primary">{{ $t("logistics.active-job") }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="card" @click="reset">
        <div class="card-content" style="padding:12px">
          <span
            class="button is-white has-text-link has-text-weight-medium"
          >{{ $t("logistics.cannot-find-right-vehicle") }}</span>
          <a class="button is-rounded is-link is-outlined">{{ $t("reset") }}</a>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "LogisticsFleetList",
  props: {
    filters: Object,
    sort: String
  },
  data() {
    return {
      selected: null,
      // sortBy: "alphabet",
      search: "", // search
      category: null,
      filter: null,
      z: 0
    };
  },
  computed: {
    noVehicles() {
      if (this.vehicles.length > 0) return false;
      return true;
    },
    vehicles() {
      // return this.$store.getters.getLogisticsFleet;
      return this.sortBy(this.$store.getters.getLogisticsFleet, this.sort);
    },
    filteredVehicles() {
      if (!this.filters) return this.vehicles;
      var filtered = this.vehicles;
      if (this.filters.working) {
        filtered = filtered.filter(v => v.role.state === "working");
      }
      if (this.filters.vehicleTypes.length > 0) {
        var types = this.filters.vehicleTypes;
        filtered = filtered.filter(v => types.includes(v.role.workflow_name));
      }
      if (this.filters.search) {
        filtered = filtered.filter(v =>
          JSON.stringify(v)
            .toLowerCase()
            .includes(this.filters.search)
        );
      }
      return filtered;
    },
    categories() {
      return [...new Set(this.vehicles.map(b => b.role.workflow_name))];
    },
    ongoingOrders() {
      return this.$store.getters.getLogisticsAgentOngoingOrders;
    }
    // showWorking() {
    //   if (!this.filters) return false;
    //   return this.filters.working;
    // }
  },
  activated() {
    this.console("activated shopList");
    // setTimeout(() => this.updateDistances(), 500);
  },
  mounted() {
    // this.updateDistances();

    EventBus.$on("SHOP_LIST_SORT", type => (this.sortBy = type));
    EventBus.$on("SHOP_LIST_SEARCH", search => (this.search = search));
    EventBus.$on("SHOP_LIST_CHANGE", () => {
      //   this.updateDistances();
      this.category = null;
      this.filter = null;
    });
  },
  methods: {
    reset() {
      EventBus.$emit("LOGISTICS_FLEET_RESET_FILTERS");
      this.infoToast("Reset fleet list");
    },
    hasActiveJob(v) {
      var activeJob = this.ongoingOrders.find(j => j.handled_by === v.id);
      if (activeJob) return true;
      return false;
    },
    translateFilter(f) {
      var name = f.toLowerCase().replace(/\s+/g, "-"); // if multi-word how?
      return this.$t(`filter.${name}`);
    },
    // translateCategory(c) {
    //   if (!c) return null;
    //   var name = c.toLowerCase().replace(/\s+/g, "-"); // if multi-word how?
    //   return this.$t(`category.${name}`);
    // },
    isWorking(us) {
      return us.role.state === "working"; // user_state
    },
    distanceColor(distance) {
      if (distance < 1500) return "color1";
      if (distance < 5000) return "color2";
      if (distance < 10000) return "color3";
      return "color4";
    },
    businessType(v) {
      return v.role.workflow_name;
      //   // main category to show in shops list
      //   var cat = v.role.workflow_name; // default cat is business_type
      //   if (!this.$store.getters.isShops) {
      //     // else it's services so get first category if exists
      //     if (b.data.categories) cat = b.data.categories.split(",")[0];
      //   }
      //   return this.translateCategory(cat);
    },
    shortName(v) {
      return this.shortenString(v.user.name, 30);
    },
    sortBy(arr, sort) {
      if (sort === "Name") return this.sortName(arr);
      if (sort === "Time") return this.sortTime(arr);
      return arr;
    },
    sortName(arr) {
      return arr.sort((a, b) => {
        var textA = a.user.name.toUpperCase();
        var textB = b.user.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },
    sortTime(arr) {
      return arr.sort((a, b) => {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });
    },
    sortAlphabet(arr, field) {
      return arr.sort((a, b) => {
        var textA = a[field].toUpperCase();
        var textB = b[field].toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },
    sortDistance(arr, field) {
      return arr.sort((a, b) => {
        return a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0;
      });
    },
    userProfilePic(v) {
      if (v.user.profile_pic_url !== "") return v.user.profile_pic_url;
      return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png"; // default profile photo
    },
    tagColor(type) {
      var accommodations = ["Apartment", "Condominium", "Hotel"];
      if (accommodations.includes(type)) return "is-success";
      var transport = ["Songthaew", "Tuk Tuk", "Motocy", "Sii Lor", "Taxi"];
      if (transport.includes(type)) return "is-danger";
      var services = ["Bar", "Restaurant", "Shop"];
      if (services.includes(type)) return "is-info";
      if (type === "Other" || type === "Service") return "is-dark";
      if (type === "TUK") return "is-warning";
    },
    openDriverModal(v) {
      var fleet = v.role.workflow_name;
      var name = v.user.name;
      var mobile = v.user.phone_number;
      var updated = this.shortDateTime(v.updated_at);
      var blue = this.bulmaColor("info");
      var callDriver = this.$t("call-driver");
      var fleetTxt = this.$t("logistics.fleet");
      var driverInfo = this.$t("logistics.driver-info");
      var nameTxt = this.$t("profile.name");
      var mobileTxt = this.$t("profile.mobile");
      var lastActive = this.$t("last-active");
      this.$swal({
        title: `<div style='color:${blue}'><i class='fa fa-truck'></i>&nbsp;${driverInfo}</div>`,
        html: `<div style='text-align:left'>
        ${fleetTxt}: <strong>${fleet}</strong><br>
        ${nameTxt}: <strong>${name}</strong><br>
        ${mobileTxt}: <strong>${mobile}</strong><br>
        ${lastActive}: <strong>${updated}</strong>
        </div>`,
        showCloseButton: true,
        confirmButtonColor: blue,
        confirmButtonText: `<i class='fa fa-phone'></i>&nbsp;${callDriver}`
      }).then(val => {
        if (val.value) this.callPhoneNumber(v.user.phone_number);
      });
    }
  }
};
</script>

<style scoped>
.fleet-list {
  width: 100vw;
  overflow-y: scroll;
  height: calc(100vh - 140px);
  border-top: 1px solid rgba(128, 128, 128, 0.181);
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.shop-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
img {
  border-radius: 5px;
  object-fit: cover;
  height: 64px;
  width: 64px;

  /* border-radius: 50%; */
  /* background: url("../assets/live-stripes.jpg"); */
  background: rgba(128, 128, 128, 0.5);
  padding: 1px;
}
.shop-card:active {
  transform: rotate(355deg);
  -webkit-transform: rotate(355deg);
  -ms-transform: rotate(355deg);
}
.tag {
  padding: 6px;
}
.button {
  padding: 9px;
}
.distance {
  text-shadow: 0 0 1px white;
}
.color1 {
  color: #1a9850 !important;
}
.color2 {
  color: #91cf60 !important;
}
.color3 {
  color: #fc8d59 !important;
}
.color4 {
  color: #d73027 !important;
}
</style>